import makeStyles from '@mui/styles/makeStyles';
import { CircularProgress, styled } from "@mui/material";

export const LoadingStyled = styled(CircularProgress)(() => ({
  color: "#475467",
}));

const styles = makeStyles(() => ({
  confirmModal: {
    maxWidth: "520px",
    width: "520px",
  },
  confirmModalText: {
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 400,
    marginBottom: "16px",
    color: "#232325",
  },
  confirmModalWarning: {
    fontFamily: "Inter",
    fontStyle: "italic",
    fontSize: "16px",
    fontWeight: 400,
    marginBottom: "16px",
    color: "#D92D20",
  },
}));

export default styles;
